// import React from "react";
// import { Link, Outlet } from "react-router-dom";
// import { useSelector } from "react-redux";

// const Account = () => {
//   const user = useSelector((state) => state.user.user);

//   return (
//     <div className="min-h-screen bg-gray-100 py-8">
//       <div className="container mx-auto px-4 flex gap-6">

//         {/* Sidebar */}
//         <div className="w-64 bg-white rounded shadow p-4">

//           <div className="mb-6">
//             <h2 className="font-semibold text-lg">{user?.name}</h2>
//             <p className="text-sm text-gray-500">{user?.email}</p>
//           </div>

//           <nav className="flex flex-col gap-3 text-sm">

//             <Link to="profile" className="hover:text-red-600">
//               My Profile
//             </Link>

//             <Link to="orders" className="hover:text-red-600">
//               My Orders
//             </Link>

//             <Link to="address" className="hover:text-red-600">
//               Address
//             </Link>

//             <Link to="wallet" className="hover:text-red-600">
//               Wallet
//             </Link>

//             <Link to="help" className="hover:text-red-600">
//               Help Center
//             </Link>

//             {user?.role === "ADMIN" && (
//               <Link
//                 to="/dashboard"
//                 className="text-blue-600 font-medium"
//               >
//                 Admin Panel
//               </Link>
//             )}

//           </nav>
//         </div>

//         {/* Content */}
//         <div className="flex-1 bg-white rounded shadow p-6">
//           <Outlet />
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Account;
import React, { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const Account = () => {
  const user = useSelector((state) => state.user.user);
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-100 py-4 md:py-8">

      <div className="max-w-7xl mx-auto px-3 md:px-4">

        {/* 🔥 MOBILE HEADER */}
        <div className="md:hidden flex justify-between items-center mb-4">
          <h2 className="font-semibold text-lg">My Account</h2>

          <button
            onClick={() => setOpen(!open)}
            className="bg-black text-white px-3 py-1 rounded"
          >
            Menu
          </button>
        </div>

        <div className="flex flex-col md:flex-row gap-4 md:gap-6">

          {/* 🔥 SIDEBAR */}
          <div
            className={`
              ${open ? "block" : "hidden"} 
              md:block
              w-full md:w-64 
              bg-white rounded shadow p-4
            `}
          >

            <div className="mb-6 border-b pb-3">
              <h2 className="font-semibold text-base md:text-lg">
                {user?.name}
              </h2>
              <p className="text-xs md:text-sm text-gray-500">
                {user?.email}
              </p>
            </div>

            <nav className="flex flex-col gap-3 text-sm">

              <Link to="profile" className="hover:text-red-600">
                My Profile
              </Link>

              <Link to="orders" className="hover:text-red-600">
                My Orders
              </Link>

              <Link to="address" className="hover:text-red-600">
                Address
              </Link>

              <Link to="wallet" className="hover:text-red-600">
                Wallet
              </Link>

              <Link to="help" className="hover:text-red-600">
                Help Center
              </Link>

              {user?.role === "ADMIN" && (
                <Link
                  to="/dashboard"
                  className="text-blue-600 font-medium"
                >
                  Admin Panel
                </Link>
              )}

            </nav>
          </div>

          {/* 🔥 CONTENT */}
          <div className="flex-1 bg-white rounded shadow p-4 md:p-6">
            <Outlet />
          </div>

        </div>

      </div>
    </div>
  );
};

export default Account;